<script>
import { mapActions } from 'vuex';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import ModalNumBillComponent from '@/components/debts/ModaNumBillComponent.vue';
import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';

export default {
	name: "statement-account",
	components: {
		ModalNumBillComponent,
		ModalFormComponentContracts
	},
	data() {
		return {
			editPay: false,
			catalogue: new Catalogue(),
			search: {
				user_id: '',
				department_id: '',
				tenant_id: '',
			},
			mail: {
				email: '',
				message: ''
			},
			tenants: [],
			errors: {},
			tenant: {
				id: '',
			},
			load: false,
			sendMailB: false,
			tenantsInfo: []
		}
	},
	methods: {
		showNewContracts(contract_id) {   
            Event.$emit('event-show-showContractID', contract_id);
        },	
		setNumberBill(tenant, service, type, pay, edit) {
			this.editPay = edit;
			Event.$emit('event-show-addBillServiceTenants', tenant, service, type, pay);
		},
		async generateBillExternal(id) {
			this.$swal({
				title: 'Crear factura',
				text: '¿ Seguro que quiere crear la factura ?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Facturar',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.numbers = [];
					let _endpoint = '/external_bill';
					let data_form = new FormData();
					data_form.append('id', id);
					this.load = true;
					try {
						let { data } = await request.postMedia(_endpoint, data_form)
						if (data) {
							this.successNotification(data.message);
							this.list();
						}
					} catch (error) {
						this.load = false;
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
						}
					}
				}
			});
		},
		getTotalRemaining(tenant, service_id) {
			const totalPaid = this.getPayService(tenant, service_id)?.reduce((sum, item) => {
				return sum + (Number(item.pay?.amount) || 0);
			}, 0) || 0;
			return totalPaid;
		},
		sedTenant() {
			this.$modal.show('addSiganturePay');
		},
		closedModalMail() {
			this.mail.email = '';
			this.mail.message = '';
			this.$modal.hide('addSiganturePay');
		},
		getTotalDebt(tenants) {
			let totalDebt = 0;

			tenants.forEach(tenant => {
				let ids = [0];

				// Procesa services_extras
				if (tenant.services_extras) {
					tenant.services_extras.forEach(function (valor) {
						ids.push(valor.id);
					});
				}

				// Procesa services_extras_no_service
				if (tenant.services_extras_no_service) {
					tenant.services_extras_no_service.forEach(function (valor) {
						ids.push(valor.id);
					});
				}

				// Si el tenant no tiene bills_numbers, continúa con el siguiente tenant
				if (!tenant || !tenant.bills_numbers) return;

				// Suma la deuda de este tenant
				totalDebt += tenant.bills_numbers
					.filter(bill => ids.includes(bill.service_id)) // Filtra por service_id
					.reduce((sum, bill) => sum + (Number(bill.pay?.amount) || 0), 0);
			});

			return totalDebt;
		},

		getTotalPaid(tenants) {
			let sum = 0;
			if (tenants) {
				tenants.forEach(function (tenant) {

					sum += (tenant.amount * 1)
					if (tenant.services_extras) {
						tenant.services_extras.forEach(function (valor) {
							if (valor.pivot) {
								sum += (valor.pivot.amount * 1)
							}
						});
					}

					if (tenant.services_extras_no_service) {
						tenant.services_extras_no_service.forEach(function (valor) {
							if (valor.extra == 1) {
								if (valor.negative == 1) {
									sum -= (valor.amount * 1)
								} else {
									sum += (valor.amount * 1)
								}
							}
						});
					}
				});
			}
			return sum
		},
		getPayService(tenant, service_id) {
			if (tenant.bills_numbers) {
				const filteredBill = tenant.bills_numbers.filter(bill => bill.service_id === service_id);
				if (filteredBill.length > 0) {
					return filteredBill;
				} else {
					return [];
				}
			} else {
				return [];
			}
		},
		sumServices(tenant) {
			console.log(tenant);
			let sum = 0;
			if (tenant) {
				sum += (tenant.amount * 1)
				if (tenant.services_extras) {
					tenant.services_extras.forEach(function (valor) {
						if (valor.pivot) {
							if (valor.pivot.group_bill == 1) {
								sum += (valor.pivot.amount * 1)
							}
						}
					});
				}

				if (tenant.services_extras_no_service) {
					tenant.services_extras_no_service.forEach(function (valor) {
						if (valor.extra == 1) {
							if (valor.negative == 1) {
								sum -= (valor.amount * 1)
							} else {
								sum += (valor.amount * 1)
							}
						}
					});
				}
			}
			return sum

		},
		getDepartment() {
			this.catalogue.get_departamens_user(this.search.user_id);
			this.search.department_id = '';
			this.search.tenant_id = '';
			this.tenantsInfo = [];
			this.tenants = [];
		},
		async getTenants() {
			let vm = this;
			this.load = true;

			let search = {
				user_id: this.search.user_id,
				department_id: this.search.department_id,
			};

			// let _endpoint = '/tenant_statements_accounts';
			let _endpoint = '/contract_statements_accounts';
			try {
				let { data } = await request.get(_endpoint, search)
				if (data) {
					console.log(data);
					vm.tenantsInfo = data;
					// if (vm.tenantsInfo.length > 0) {
					// 	if (vm.tenantsInfo[0].tenant) {
					// 		if (vm.tenantsInfo[0].tenant.user) {
					// 			this.mail.email = vm.tenantsInfo[0].tenant.user.email;							
					// 		}							
					// 	}
					// }
					vm.load = false;
				}
			} catch (error) {
				console.log(error);
				vm.load = false;
			}
		},
		closedModal() {
			this.tenant = {};
			this.tenantsInfo = [];

			this.search.department_id = '';
			this.search.tenant_id = '';
			this.search.user_id = '';
			this.tenants = [];
			this.errors = {};

			Event.$emit('event-load-tenants');
			this.$modal.hide('ListServicesExtrasAll');
		},
		async sendMail() {
			this.sendMailB = true;
			
				let service = request;
				let _endpoint = `/tenant_statements_accounts_pdf`;
				let form = {
					user_id: this.search.user_id,
					department_id: this.search.department_id,
					email: this.mail.email,
					message: this.mail.message
				};
				try {
					let { data } = await service.post(_endpoint, form)
					if (data) {
						this.sendMailB = false;
						this.successNotification(data.message);
						this.closedModalMail();
					}
				} catch (error) {
					this.sendMailB = false;
					this.errors = {};
					if (error.response) {
						this.errors = await this.errorNotification(error);
					}
					console.log(error);
				}
			
		},
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	mounted() {
		this.catalogue.get_users_profile(7);
	},
	created() {
		Event.$on("event-list-extra-services-all", () => {
			this.$modal.show('ListServicesExtrasAll');
		});
	},
	computed: {
		totals() {
			return this.tenantsInfo.reduce(
				(acc, item) => {
					const pays = parseFloat(item.pays) || 0;
					const amount = parseFloat(item.amount) || 0;

					acc.pays += pays;
					acc.amount += amount;
					acc.remaining += (amount - pays);

					return acc;
				},
				{ pays: 0, amount: 0, remaining: 0 }
			);
		}
	},
	watch: {


	}
}
</script>

<template>
	<div class="col-12">
		<ModalNumBillComponent :prop_edit="editPay" />
		<ModalFormComponentContracts :prop_edit="false" />
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Estado de cuentas</h3>
				<div class="card-tools">

				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<label>Cliente :</label>
						<select class="form-control" v-model="search.user_id" @change="getDepartment()">
							<option value="">Sin cliente</option>
							<option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
								:key="user_index">{{ user.name }} {{ user.last_name }}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label> Indiviso :</label>
						<select class="form-control" v-model="search.department_id" @change="getTenants()">
							<option value="">Sin indiviso </option>
							<option :value="company.id" v-for="(company, index) in catalogue.departamens_user"
								:key="index">
								{{ company.name }}
							</option>
						</select>
					</div>
					<div class="col-md-12">
						<hr>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-12 table-responsive">
						<table class="table table-bordered tbl-pays">
							<thead>
								<tr>
									<th>Fecha cargo</th>
									<th>Concepto</th>
									<th>Abono</th>
									<th>Cargo</th>
									<th>Saldo</th>
									<th>Opciones</th>
								</tr>
							</thead>
							<tbody v-if="load">
								<tr>
									<td align="center" colspan="6">
										<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
										<h5>Cargando</h5>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="tenantsInfo.length > 0">
								<tr v-for="(service, index) in tenantsInfo" :key="'tenant-' + index">

									<td>
										{{ service.date | toDateTime }}
									</td>
									<td>
										<span v-for="(item, idx) in service.items" :key="'service-name-' + idx">
											{{ item.name }}
											<hr v-if="idx < service.items.length - 1">
										</span>
									</td>
									<td>
										{{ service.pays | toCurrency }}
									</td>
									<td>
										{{ service.amount | toCurrency }}
									</td>
									<td>
										{{ service.amount - service.pays | toCurrency }}
									</td>

									<td>
										<button class="btn btn-sm btn-outline-success" @click="showNewContracts(val.contact_id)">
											<i class="fa fa-eye"></i> <br> Ver contrato
										</button>
										<!-- <div v-if="service.pay_bill">
											<button
												@click="setNumberBill(service.tenant, service, service.type, service.pay_bill, false)"
												class="btn btn-outline-primary btn-sm m-1">
												<i class="fa fa-eye"></i> Ver número de factura
											</button>

											<button v-if="!service.pay_bill.external_bill"
												class="btn btn-sm m-1 btn-outline-primary"
												@click="generateBillExternal(service.pay_bill.id)">
												<i class="fa-solid fa-file-invoice"></i>
												Facturar
											</button>

											<div v-if="service.pay_bill.external_bill">
												<a :href="`${globalUrlFiles}/file/bill_external/${service.pay_bill.external_bill.id}/pdf`"
													v-if="service.pay_bill.external_bill" target="_blank"
													class="btn btn-outline-info btn-sm m-1">
													<i class="fa-regular fa-file-pdf"></i> Factura PDF
												</a>
												<a :href="`${globalUrlFiles}/file/bill_external/${service.pay_bill.external_bill.id}/xml`"
													v-if="service.pay_bill.external_bill" target="_blank"
													class="btn btn-outline-info btn-sm m-1">
													<i class="fa-regular fa-file"></i> Factura XML
												</a>
											</div>

										</div>
										<div v-else>
											<button
												@click="setNumberBill(service.tenant, service, service.type, service.pay_bill, true)" 
												class="btn btn-outline-success btn-sm m-1">
												<i class="fa fa-plus"></i> Crear número de factura
											</button>

										</div> -->
									</td>

								</tr>



							</tbody>
							<tbody v-else>
								<tr>
									<td align="center" colspan="6">Sin resultados.</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="2">
										Saldo de contrato al dia de hoy:
									</td>
									<td>{{ totals.pays | toCurrency }}</td>
									<td>{{ totals.amount | toCurrency }}</td>
									<td>{{ totals.remaining | toCurrency }}</td>
									<td class="text-right">

									</td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="col-md-12 text-right" v-if="tenantsInfo.length == 0">
						<hr>
					</div>
					<!-- <div class="col-md-12 text-right" v-if="tenantsInfo.length > 0">
						<button type="button" class="btn btn-outline-success" @click="sedTenant()">
							<i class="fa fa-envelope" aria-hidden="true"></i> Enviar por correo
						</button>
					</div> -->
				</div>
			</div>
		</div>

		<modal name="addSiganturePay" :width="'80%'" :maxHeight="380" :adaptive="true" :maxWidth="800" :height="'auto'">
			<button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModalMail()"> <i
					class="fa-solid fa-xmark"></i>
			</button>
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">Enviar estado de cuenta</h5>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-md-12">
						<label>Correos electrónicos</label>
						<input type="text" class="form-control" v-model="mail.email">
						<div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}</div>
					</div>
					<div class="col-md-12">
						<label>Mensaje</label>
						<textarea type="text" class="form-control" v-model="mail.message"></textarea>
						<div v-if="errors && errors.message" class="text-danger">{{ errors.message[0] }}</div>
					</div>
					<div class="col-md-12">
						<hr>
					</div>
					<div class="col-md-12">
						<button @click="sendMail()" :disables="sendMailB" type="button"
							class="btn float-right btn-outline-success">
							<span v-if="sendMailB">
								<i class="fa-solid fa-circle-notch fa-spin"></i> Enviando
							</span>
							<span v-else>
								<i class="fas fa-save"></i> Enviar
							</span>
						</button>
						<button type="button" @click="closedModalMail()" class="btn float-left btn-outline-warning">
							<i class="fas fa-undo-alt"></i>
							Regresar
						</button>
					</div>
				</div>
			</div>
		</modal>


	</div>
</template>


<style scoped>
.pagination {
	margin-bottom: 0;
}

.tbl-pays {
	table-layout: fixed;
	min-width: 900px;
	width: 100%;
}
</style>
